import {
	Container,
	ContainerGutter,
	CTA,
	styled,
	Text,
	TextAlignment,
	ThemeProvider,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { useHuchaPopup } from '../../../../shared/hooks/use-hucha-popup';
import { HuchaVentaValues } from '../../../../shared/models/hucha-values';
import { LogoHuchaVenta3Lines } from '../../../assets/logo-hucha-venta-3lines';
import { useHuchaVentaLayerContent } from '../../../hooks/use-hucha-venta-layer-content';

const MainContainer = styled(Container)`
	margin: auto;

	@media (min-width: 960px) {
		padding-top: 12px;
	}
`;

const HuchaLogoWrapper = styled.div`
	width: 100%;
	max-width: 275px;
	min-width: 200px;
`;

const AlignedContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: fit-content;
	gap: 20px;
`;

export const HuchaRenovadoresCardC1 = ({ huchaValues }: { huchaValues: HuchaVentaValues }) => {
	const { huchaVentaPopupLayerContent } = useHuchaVentaLayerContent(huchaValues);
	const { handlePopupOpen } = useHuchaPopup({ huchaValues, layerContent: () => huchaVentaPopupLayerContent });
	return (
		<MainContainer data-testid="c1-container" stretchContent gutter={ContainerGutter.static300} wrap="always">
			<HuchaLogoWrapper>
				<LogoHuchaVenta3Lines />
			</HuchaLogoWrapper>

			<AlignedContainer>
				<Text
					appearance={TokenTextAppearance.headline100}
					color={TokenTextColor.inverted}
					textAlign={TextAlignment.left}
					bold
				>
					{'Cada mes, acumulas 10€ para tu próximo Volkswagen'}
				</Text>

				<ThemeProvider theme="inverted">
					<CTA tag="button" emphasis="primary" onClick={handlePopupOpen}>
						Aprovéchalos
					</CTA>
				</ThemeProvider>
			</AlignedContainer>
		</MainContainer>
	);
};
